function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('./../../lib/saito/saito');
var OnePlayerGameTemplate = require('../../lib/templates/oneplayer-gametemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var NwasmGameOptionsTemplate = require('./lib/nwasm-game-options.template');
var NwasmUI = require('./lib/ui/main');
var xorInplace = require('buffer-xor/inplace');
var Transaction = require('../../lib/saito/transaction')["default"];

//
// NWasm
//
// Local ROM archive, emulator, and save-game support.
//
// 	ROMS -- saved as 'Nwasm' modules in the local transaction archive
// 	SAVEGAMES --- saved as 'Nwasm' + hash(title)
//
// Lending/borrowing and peer ROM discovery are intentionally not implemented
// here. Future ownership/permission workflows belong in Vault + scripting.
//
var Nwasm = /*#__PURE__*/function (_OnePlayerGameTemplat) {
  function Nwasm(app) {
    var _this;
    _classCallCheck(this, Nwasm);
    _this = _callSuper(this, Nwasm, [app]);
    _this.app = app;
    _this.name = 'Nwasm';
    _this.slug = 'nwasm';
    _this.gamename = 'Nintendo 64';
    _this.description = "The Saito Nintendo 64 emulator provides a user-friendly in-browser N64 emulator that allows archiving and playing the N64 games you own directly in your browser. Game files are encrypted so only you can access them and archived in your private transaction store.";
    _this.categories = 'Games Videogame Classic';
    _this.status = 'beta';
    _this["class"] = 'utility';
    _this.ui = new NwasmUI(_this.app, _this);
    _this.active_rom = null;
    _this.active_rom_name = '';
    _this.active_rom_sig = '';
    // Library sig of the game currently being launched (for different-ROM reload).
    _this.launch_sig = '';
    _this.active_game = new ArrayBuffer(8);
    _this.active_game_img = '';
    _this.active_game_saves = [];
    _this.active_game_time_played = 0;
    _this.active_game_load_ts = 0;
    _this.active_game_save_ts = 0;
    _this.uploaded_rom = false;
    _this.rental_timer = null;
    _this.rental_game_sig = null;

    // opt out of index.js
    _this.default_html = 0;
    return _this;
  }

  /////////////////////////////////
  // inter-module communications //
  /////////////////////////////////
  _inherits(Nwasm, _OnePlayerGameTemplat);
  return _createClass(Nwasm, [{
    key: "respondTo",
    value: function respondTo() {
      var _this2 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      if (type === 'saito-create-nft') {
        return {
          title: 'N64 ROM',
          "class": ['nwasm-nft-mod'],
          upload_text: 'Upload an N64 ROM you own',
          upload_icon: 'fa-solid fa-compact-disc',
          createData: function () {
            var _createData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(modfile) {
              var metadata,
                _args = arguments;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    metadata = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                    return _context.a(2, {
                      module: 'Nwasm',
                      name: (metadata.title || '').trim(),
                      file: modfile
                    });
                }
              }, _callee);
            }));
            function createData(_x) {
              return _createData.apply(this, arguments);
            }
            return createData;
          }()
        };
      }

      //
      // Arcade discovers this module via arcade-games. Supply onClick so the
      // Nintendo 64 card opens NWASM's Arcade overlay (not the Game Wizard).
      // Arcade only invokes Game.onClick() — it does not know about this overlay.
      //
      if (type === 'arcade-games') {
        var pack = _superPropGet(Nwasm, "respondTo", this, 3)([type, obj]) || {};
        pack.onClick = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this2.openArcadeOverlay();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return pack;
      }
      return _superPropGet(Nwasm, "respondTo", this, 3)([type, obj]);
    }

    /**
     * Open the NWASM Arcade library overlay without leaving the Arcade page.
     */
  }, {
    key: "openArcadeOverlay",
    value: function () {
      var _openArcadeOverlay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var NwasmArcadeOverlay;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.ensureArcadeStyles();
              if (!this.arcade_overlay) {
                NwasmArcadeOverlay = require('./lib/ui/overlays/arcade_overlay');
                this.arcade_overlay = new NwasmArcadeOverlay(this.app, this);
              }
              _context3.n = 2;
              return this.arcade_overlay.open();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function openArcadeOverlay() {
        return _openArcadeOverlay.apply(this, arguments);
      }
      return openArcadeOverlay;
    }()
    /**
     * Open the Arcade game wizard for an installed ROM (explicit Play launches emulator).
     */
  }, {
    key: "openRomWizard",
    value: function openRomWizard() {
      var sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!this.app.BROWSER || !sig) {
        return;
      }
      this.app.connection.emit('arcade-launch-game-wizard', {
        game: this.name,
        rom_sig: sig,
        rom_title: title || ''
      });
    }

    /**
     * Called from the Arcade game wizard when the user explicitly chooses Play.
     */
  }, {
    key: "launchFromArcadeWizard",
    value: function launchFromArcadeWizard() {
      var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (obj !== null && obj !== void 0 && obj.rom_sig) {
        this.launchRomFromArcade(obj.rom_sig);
      }
    }
  }, {
    key: "ensureArcadeStyles",
    value: function ensureArcadeStyles() {
      if (!this.styles.includes('/nwasm/style.css')) {
        this.styles.push('/nwasm/style.css');
      }
      if (!document.querySelector('link[href*="/nwasm/style.css"]')) {
        this.stylesheetAdded = false;
        this.attachStyleSheets();
      }
    }

    /**
     * Launch an installed ROM by navigating into the NWASM player page and
     * resuming via the existing pending-launch path.
     */
  }, {
    key: "launchRomFromArcade",
    value: function launchRomFromArcade() {
      var sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!sig) {
        return;
      }
      try {
        sessionStorage.setItem('nwasm-pending-launch', JSON.stringify({
          sig: String(sig)
        }));
        sessionStorage.setItem('nwasm-launched-from-arcade', '1');
      } catch (_) {}
      navigateWindow('/nwasm/');
    }

    /**
     * Play an uploaded ROM immediately (standalone /nwasm/ page).
     */
  }, {
    key: "playEphemeralRom",
    value: function () {
      var _playEphemeralRom = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(byteArray) {
        var file_name,
          raw_file,
          title,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              file_name = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : '';
              raw_file = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : null;
              if (!(!byteArray || !this.ui)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              title = file_name || 'Loading game…';
              this.ui.hide();
              this.ui.load_overlay.render({
                title: title,
                message: 'Initializing emulator — this can take a while for large ROMs. The page may appear frozen; please wait.'
              });
              _context4.n = 2;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(resolve);
                });
              });
            case 2:
              _context4.n = 3;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50);
              });
            case 3:
              this.active_rom = raw_file || byteArray;
              this.uploaded_rom = true;
              this.launch_sig = '';
              this.clearRentalTimer();
              this.startPlaying();
              myApp.initializeRom(byteArray, this.app, this);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function playEphemeralRom(_x2) {
        return _playEphemeralRom.apply(this, arguments);
      }
      return playEphemeralRom;
    }()
    /**
     * When Play Now is chosen from the Arcade overlay, queue ROM bytes and
     * navigate into the NWASM player page (same host as library launches).
     */
  }, {
    key: "queueEphemeralRomFromArcade",
    value: function queueEphemeralRomFromArcade(file) {
      var _this$arcade_overlay;
      var file_name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!file) {
        return false;
      }
      try {
        var data = Buffer.from(file, 'binary').toString('base64');
        sessionStorage.setItem('nwasm-pending-ephemeral', JSON.stringify({
          data: data,
          file_name: file_name || 'Selected ROM'
        }));
        sessionStorage.setItem('nwasm-launched-from-arcade', '1');
      } catch (err) {
        alert('Unable to launch this ROM from Arcade. Add it to your library first, then play.');
        return false;
      }
      if ((_this$arcade_overlay = this.arcade_overlay) !== null && _this$arcade_overlay !== void 0 && _this$arcade_overlay.is_open) {
        this.arcade_overlay.close();
      }
      navigateWindow('/nwasm/');
      return true;
    }
  }, {
    key: "is_nwasm_page",
    value: function is_nwasm_page() {
      try {
        return String(window.location.pathname || '').includes('/nwasm');
      } catch (_) {
        return false;
      }
    }

    /**
     * Publish installed ROM titles to Arcade as ordinary Game objects with
     * NWASM-owned onClick handlers. Does not block Arcade initialization.
     *
     * When `games` is a full installed list, stale Arcade ROM teasers are pruned.
     * Pass `{ prune: false }` for partial updates (e.g. after registering one ROM).
     */
  }, {
    key: "syncArcadeGames",
    value: function syncArcadeGames() {
      var _this$ui,
        _this3 = this;
      var games = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.app.BROWSER) {
        return;
      }
      var arcade = this.app.modules.returnModule('Arcade');
      if (!arcade || typeof arcade.addGame !== 'function') {
        return;
      }
      var list = Array.isArray(games) ? games : ((_this$ui = this.ui) === null || _this$ui === void 0 ? void 0 : _this$ui.games) || [];
      var prune = opts.prune !== false && Array.isArray(games);
      var prefix = 'nwasm-rom-';
      var keep = {};
      var _loop = function _loop() {
        var g = list[i];
        if (!(g !== null && g !== void 0 && g.sig)) {
          return 1; // continue
        }
        var name = prefix + g.sig;
        keep[name] = 1;
        arcade.addGame({
          name: name,
          title: g.title || 'N64 ROM',
          image: _this3.returnImage(),
          onClick: function () {
            var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
              return _regenerator().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    _this3.openRomWizard(g.sig, g.title);
                  case 1:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
            function onClick() {
              return _onClick.apply(this, arguments);
            }
            return onClick;
          }()
        });
      };
      for (var i = 0; i < list.length; i++) {
        if (_loop()) continue;
      }
      if (prune && Array.isArray(arcade.games)) {
        var stale = arcade.games.filter(function (g) {
          var _g$name;
          return (g === null || g === void 0 || (_g$name = g.name) === null || _g$name === void 0 ? void 0 : _g$name.startsWith(prefix)) && !keep[g.name];
        }).map(function (g) {
          return g.name;
        });
        for (var _i = 0; _i < stale.length; _i++) {
          if (typeof arcade.removeGame === 'function') {
            arcade.removeGame(stale[_i]);
          }
        }
      }
      if (typeof arcade.renderGames === 'function') {
        arcade.renderGames();
      }
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, peer) {
        var service,
          vault_mod,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              service = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              //
              // Wire Vault peer connectivity when a Vault service peer is available.
              // Required for existing Vault-backed ROM access; not a Library protocol.
              //
              if (service.service === 'vault') {
                vault_mod = app.modules.returnModule('Vault');
                if (vault_mod) {
                  vault_mod.peer = peer;
                  vault_mod.peer_connected = true;
                }
              }
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() //
    // when this game initializes it begins to monitor the console log. this is
    // used to provide feedback into the Saito module when the game has loaded
    // and when it is saving or loading files, etc.
    //
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app) {
        var _this4 = this;
        var log;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _superPropGet(Nwasm, "initialize", this, 3)([app]);
            case 1:
              if (!(app.BROWSER == 0)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              //
              // monitor log if browser
              //
              if (this.browser_active == 1) {
                {
                  log = console.log.bind(console);
                  console.log = function () {
                    if (arguments.length > 0) {
                      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
                        _this4.processNwasmLog(arguments.length <= 0 ? undefined : arguments[0], log);
                      }
                      log.apply(void 0, arguments);
                    }
                  };
                }
              }

              //
              // After all modules finish initialize (setTimeout 0), publish installed
              // ROMs to Arcade. Discovery is async and must not block Arcade load.
              //
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
                var games, _t;
                return _regenerator().w(function (_context7) {
                  while (1) switch (_context7.p = _context7.n) {
                    case 0:
                      _context7.p = 0;
                      _context7.n = 1;
                      return _this4.ui.load_games();
                    case 1:
                      games = _context7.v;
                      _this4.ui.games = games;
                      _this4.syncArcadeGames(games);
                      _context7.n = 3;
                      break;
                    case 2:
                      _context7.p = 2;
                      _t = _context7.v;
                      console.warn('Nwasm: deferred Arcade sync failed:', _t);
                    case 3:
                      return _context7.a(2);
                  }
                }, _callee7, null, [[0, 2]]);
              })), 0);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function initialize(_x5) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() //////////////////////
    // UI and Rendering //
    //////////////////////
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (this.browser_active) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              if (this.header) {
                _context0.n = 2;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              this.header.header_class = 'game';
              _context0.n = 2;
              return this.header.initialize(this.app);
            case 2:
              _context0.n = 3;
              return _superPropGet(Nwasm, "render", this, 3)([app]);
            case 3:
              if (!this.header) {
                _context0.n = 4;
                break;
              }
              _context0.n = 4;
              return this.header.render();
            case 4:
              this.menu.addMenuOption('game-game', 'Game');
              this.menu.addSubMenuOption('game-game', {
                text: 'Upload',
                id: 'game-upload-rom',
                "class": 'game-upload-rom',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.ui.open_upload();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Save',
                id: 'game-export',
                "class": 'game-export',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.exportState();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Load',
                id: 'game-import',
                "class": 'game-import',
                callback: function () {
                  var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(app, game_mod) {
                    return _regenerator().w(function (_context9) {
                      while (1) switch (_context9.n) {
                        case 0:
                          game_mod.menu.hideSubMenus();
                          _context9.n = 1;
                          return game_mod.ui.open_save_games();
                        case 1:
                          return _context9.a(2);
                      }
                    }, _callee9);
                  }));
                  function callback(_x7, _x8) {
                    return _callback.apply(this, arguments);
                  }
                  return callback;
                }()
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Controls',
                id: 'game-controls',
                "class": 'game-controls',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.ui.open_controls();
                }
              });
              this.menu.addChatMenu();
              this.menu.render();

              //
              // GameMenu.render() installs a default Export (game JSON) that replaces our
              // emulator Save (same id). Re-assert NWASM Save/Load/Exit after that.
              //
              this.menu.addSubMenuOption('game-game', {
                text: 'Save',
                id: 'game-export',
                "class": 'game-export',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  game_mod.exportState();
                }
              });
              this.menu.addSubMenuOption('game-game', {
                text: 'Exit',
                id: 'game-exit',
                "class": 'game-exit',
                callback: function callback(app, game_mod) {
                  game_mod.menu.hideSubMenus();
                  // Stop audio-driven Module._runMainLoop() before leaving the game UI.
                  try {
                    if (typeof myApp !== 'undefined' && myApp.stopEmulator) {
                      myApp.stopEmulator();
                    }
                  } catch (err) {}
                  game_mod.clearRentalTimer();
                  game_mod.stopPlaying();
                  var from_arcade = false;
                  try {
                    from_arcade = sessionStorage.getItem('nwasm-launched-from-arcade') === '1';
                    if (from_arcade) {
                      sessionStorage.removeItem('nwasm-launched-from-arcade');
                    }
                  } catch (_) {}
                  if (from_arcade) {
                    navigateWindow('/arcade');
                  } else {
                    game_mod.ui.return_to_launcher();
                  }
                }
              });
              this.menu.render();
              _context0.n = 5;
              return this.ui.render();
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function render(_x6) {
        return _render.apply(this, arguments);
      }
      return render;
    }() /////////////////////////
    // Game Engine Support //
    /////////////////////////
  }, {
    key: "initializeGame",
    value: function initializeGame(game_id) {
      var nwasm_self = this;
      if (!this.game.state) {
        this.game.state = {};
        this.game.queue = [];
        this.game.queue.push('round');
        this.game.queue.push('READY');
      }

      //
      // when games are saved in the emulator
      //
      this.app.connection.on('nwasm-export-game-save', function (savegame) {
        nwasm_self.active_game = savegame;
        nwasm_self.saveGameFile(savegame);
      });
    }
  }, {
    key: "handleGameLoop",
    value: function handleGameLoop() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      ///////////
      // QUEUE //
      ///////////
      if (this.game.queue.length > 0) {
        var qe = this.game.queue.length - 1;
        var mv = this.game.queue[qe].split('\t');
        var shd_continue = 1;
        if (mv[0] === 'round') {
          this.game.queue.splice(this.game.queue.length - 1, 1);
        }
        if (shd_continue == 0) {
          return 0;
        }
      }
      return 1;
    }
  }, {
    key: "startPlaying",
    value: function startPlaying() {
      var _this$app$options;
      var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (ts == null) {
        ts = new Date().getTime();
      }
      this.active_game_load_ts = ts;
      this.active_game_save_ts = ts;

      // Record last-played on the library registry entry when we know which ROM.
      var sig = this.launch_sig || this.active_rom_sig || '';
      if (sig && (_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && (_this$app$options = _this$app$options.nwasm) !== null && _this$app$options !== void 0 && _this$app$options.library) {
        var entry = this.app.options.nwasm.library.find(function (g) {
          return (g === null || g === void 0 ? void 0 : g.sig) === sig;
        });
        if (entry) {
          entry.last_played = ts;
          this.app.storage.saveOptions();
        }
      }
    }
  }, {
    key: "stopPlaying",
    value: function stopPlaying() {
      var ts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (ts == null) {
        ts = new Date().getTime();
      }
      this.active_game_time_played += ts - this.active_game_load_ts;
      this.active_game_load_ts = ts;
    }
  }, {
    key: "isRentalExpired",
    value: function isRentalExpired() {
      var game = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!(game !== null && game !== void 0 && game.rental)) {
        return false;
      }
      var exp = game.expires_at != null ? Number(game.expires_at) : NaN;
      return !Number.isFinite(exp) || Date.now() >= exp;
    }
  }, {
    key: "clearRentalTimer",
    value: function clearRentalTimer() {
      if (this.rental_timer) {
        clearTimeout(this.rental_timer);
        this.rental_timer = null;
      }
      this.rental_game_sig = null;
    }
  }, {
    key: "armRentalExpiry",
    value: function armRentalExpiry() {
      var _this5 = this;
      var game = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.clearRentalTimer();
      if (!(game !== null && game !== void 0 && game.rental)) {
        return;
      }
      if (this.isRentalExpired(game)) {
        this.expireRental();
        return;
      }
      var exp = Number(game.expires_at);
      this.rental_game_sig = game.sig || this.launch_sig || '';
      this.rental_timer = setTimeout(function () {
        _this5.expireRental();
      }, Math.max(0, exp - Date.now()));
    }
  }, {
    key: "clearRentalRomFromMemory",
    value: function clearRentalRomFromMemory() {
      this.active_rom = null;
      this.active_game = null;
      try {
        if (typeof FS !== 'undefined' && FS.analyzePath) {
          var info = FS.analyzePath('custom.v64');
          if (info !== null && info !== void 0 && info.exists) {
            FS.unlink('custom.v64');
          }
        }
      } catch (err) {}
    }
  }, {
    key: "expireRental",
    value: function expireRental() {
      this.clearRentalTimer();
      try {
        if (typeof myApp !== 'undefined') {
          if (typeof myApp.saveStateLocal === 'function') {
            myApp.saveStateLocal();
          }
          if (typeof myApp.exportStateLocal === 'function') {
            myApp.exportStateLocal();
          }
        }
      } catch (err) {
        console.log('Nwasm: rental expiry save failed: ' + err);
      }
      try {
        if (typeof myApp !== 'undefined' && myApp.stopEmulator) {
          myApp.stopEmulator();
        }
      } catch (err) {}
      this.clearRentalRomFromMemory();
      try {
        this.stopPlaying();
      } catch (err) {}
      try {
        var _this$ui2, _this$ui3;
        if ((_this$ui2 = this.ui) !== null && _this$ui2 !== void 0 && _this$ui2.hide_loading) {
          this.ui.hide_loading();
        }
        if ((_this$ui3 = this.ui) !== null && _this$ui3 !== void 0 && _this$ui3.return_to_launcher) {
          this.ui.return_to_launcher();
        }
      } catch (err) {}
      try {
        alert('This rental has expired.');
      } catch (err) {}
    }

    ////////////////////
    // ROM Management //
    ////////////////////
    //
    // Canonical N-WASM game payload — same object Create NFT stores in txmsg.data:
    //   { module: 'Nwasm', name: ..., file: <data URI> }
    //
  }, {
    key: "createGameData",
    value: function () {
      var _createGameData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(file) {
        var file_name,
          cap,
          data_uri,
          base64,
          safe_name,
          _args1 = arguments;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              file_name = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : '';
              cap = this.respondTo('saito-create-nft');
              if (cap !== null && cap !== void 0 && cap.createData) {
                _context1.n = 1;
                break;
              }
              throw new Error('N64 ROM NFT type is unavailable');
            case 1:
              data_uri = file;
              if (typeof file !== 'string' || file.indexOf('data:') !== 0) {
                base64 = Buffer.from(file).toString('base64');
                safe_name = encodeURIComponent(file_name || 'rom.bin');
                data_uri = "data:application/octet-stream;name=".concat(safe_name, ";base64,").concat(base64);
              }
              _context1.n = 2;
              return cap.createData(data_uri, {
                title: file_name
              });
            case 2:
              return _context1.a(2, _context1.v);
          }
        }, _callee1, this);
      }));
      function createGameData(_x9) {
        return _createGameData.apply(this, arguments);
      }
      return createGameData;
    }() //
    // Persist a signed local Archive transaction whose msg.data is the canonical
    // N-WASM game payload (same structure as NFT txmsg.data).
    //
    // Do NOT set Archive `owner` to the wallet public key. Archive.enforce_access_hash
    // treats a non-empty owner as an access-script hash and will refuse to return the
    // row unless a matching access_script is supplied — which breaks load_games().
    // Scope local ROMs with field1/field2 instead.
    //
  }, {
    key: "saveGameToArchive",
    value: function () {
      var _saveGameToArchive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(game_data) {
        var _this6 = this;
        var name, publicKey, rom_id, newtx, result, err, verified, _t2;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              name = ((game_data === null || game_data === void 0 ? void 0 : game_data.name) || '').trim();
              if (!(!(game_data !== null && game_data !== void 0 && game_data.file) || !name)) {
                _context10.n = 1;
                break;
              }
              throw new Error('Invalid N-WASM game data');
            case 1:
              _t2 = this.publicKey;
              if (_t2) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              _t2 = _context10.v;
            case 3:
              publicKey = _t2;
              if (!this.publicKey && publicKey) {
                this.publicKey = publicKey;
              }
              rom_id = this.app.crypto.hash(name);
              _context10.n = 4;
              return this.app.wallet.createUnsignedTransaction();
            case 4:
              newtx = _context10.v;
              newtx.msg = {
                module: this.name,
                id: rom_id,
                type: rom_id,
                title: name,
                name: name,
                request: 'archive insert',
                data: game_data
              };
              _context10.n = 5;
              return newtx.sign();
            case 5:
              if (newtx.signature) {
                _context10.n = 6;
                break;
              }
              throw new Error('Failed to sign archive transaction');
            case 6:
              _context10.n = 7;
              return this.app.storage.saveTransaction(newtx, {
                field1: this.name,
                field2: publicKey,
                field3: name
              }, 'localhost');
            case 7:
              result = _context10.v;
              if (!(result !== null && result !== void 0 && result.err)) {
                _context10.n = 8;
                break;
              }
              err = result.err;
              throw err instanceof Error ? err : new Error(String(err || 'Archive save failed'));
            case 8:
              _context10.n = 9;
              return new Promise(function (resolve) {
                _this6.app.storage.loadTransactions({
                  field1: _this6.name,
                  limit: 100
                }, function (txs) {
                  var found = (txs || []).some(function (tx) {
                    return (tx === null || tx === void 0 ? void 0 : tx.signature) === newtx.signature;
                  });
                  resolve(found);
                }, 'localhost');
              });
            case 9:
              verified = _context10.v;
              if (verified) {
                _context10.n = 10;
                break;
              }
              throw new Error('Archive save could not be verified — ROM was not retained locally');
            case 10:
              return _context10.a(2, newtx);
          }
        }, _callee10, this);
      }));
      function saveGameToArchive(_x0) {
        return _saveGameToArchive.apply(this, arguments);
      }
      return saveGameToArchive;
    }() //
    // Register a game in the N-WASM Library registry after a successful save.
    // load_games() merges this list with Archive / wallet-NFT / Vault discovery.
    //
    // tx should carry the canonical game payload (msg.data = createGameData result,
    // or an NFT mint tx whose msg.data is that object). For Vault-only metadata
    // registration, pass sig + vault and omit tx.
    //
  }, {
    key: "addGame",
    value: function () {
      var _addGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _msg$data, _msg$data2, _meta$vault, _this$arcade_overlay2;
        var tx,
          meta,
          msg,
          _tx$returnMessage,
          sig,
          title,
          id,
          source,
          entry,
          list,
          idx,
          _this$ui4,
          _args11 = arguments,
          _t3,
          _t4;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              tx = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : null;
              meta = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};
              if (!this.app.options.nwasm) {
                this.app.options.nwasm = {};
              }
              if (!Array.isArray(this.app.options.nwasm.library)) {
                this.app.options.nwasm.library = [];
              }
              msg = {};
              try {
                msg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              } catch (err) {
                msg = {};
              }
              sig = (meta.sig || (tx === null || tx === void 0 ? void 0 : tx.signature) || '').toString();
              title = (meta.title || msg.title || msg.name || ((_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.name) || ((_msg$data2 = msg.data) === null || _msg$data2 === void 0 ? void 0 : _msg$data2.title) || '').toString().trim();
              id = (meta.id || msg.id || sig || '').toString();
              source = (meta.source || 'archive').toString();
              if (!(tx !== null && tx !== void 0 && tx.signature)) {
                _context11.n = 5;
                break;
              }
              _context11.p = 1;
              _context11.n = 2;
              return this.app.storage.saveTransaction(tx, {
                field1: this.name,
                field2: source,
                field3: title || id || sig
              }, 'localhost');
            case 2:
              _context11.n = 4;
              break;
            case 3:
              _context11.p = 3;
              _t3 = _context11.v;
              console.log('Nwasm.addGame: saveTransaction failed: ' + _t3);
            case 4:
              sig = tx.signature;
            case 5:
              if (sig) {
                _context11.n = 6;
                break;
              }
              throw new Error('Cannot register library game without a transaction signature');
            case 6:
              if (!title) {
                title = 'Untitled ROM';
              }
              entry = {
                sig: sig,
                title: title,
                id: id || sig,
                source: source,
                nft_type: meta.nft_type || ((_meta$vault = meta.vault) === null || _meta$vault === void 0 ? void 0 : _meta$vault.nft_type) || '',
                rental: meta.rental === true,
                expires_at: meta.expires_at != null ? meta.expires_at : null
              };
              if (meta.vault) {
                entry.vault = meta.vault;
              }
              list = this.app.options.nwasm.library;
              idx = list.findIndex(function (g) {
                return (g === null || g === void 0 ? void 0 : g.sig) === entry.sig || entry.id && (g === null || g === void 0 ? void 0 : g.id) && g.id === entry.id;
              });
              if (idx >= 0) {
                list[idx] = Object.assign({}, list[idx], entry);
              } else {
                list.push(entry);
              }
              this.app.storage.saveOptions();

              // Upsert this ROM into Arcade without pruning other titles.
              if (this.app.BROWSER && typeof this.syncArcadeGames === 'function') {
                try {
                  if ((_this$ui4 = this.ui) !== null && _this$ui4 !== void 0 && _this$ui4.games && !this.ui.games.some(function (g) {
                    return g.sig === entry.sig;
                  })) {
                    this.ui.games.push({
                      sig: entry.sig,
                      title: entry.title,
                      id: entry.id,
                      source: entry.source,
                      vault: entry.vault || null,
                      nft_type: entry.nft_type || '',
                      last_played: entry.last_played || 0,
                      rental: entry.rental === true,
                      expires_at: entry.expires_at != null ? entry.expires_at : null
                    });
                    this.ui.games.sort(function (a, b) {
                      return a.title.localeCompare(b.title);
                    });
                  }
                  this.syncArcadeGames([{
                    sig: entry.sig,
                    title: entry.title,
                    id: entry.id,
                    source: entry.source,
                    vault: entry.vault || null,
                    nft_type: entry.nft_type || '',
                    last_played: entry.last_played || 0,
                    rental: entry.rental === true,
                    expires_at: entry.expires_at != null ? entry.expires_at : null
                  }], {
                    prune: false
                  });
                } catch (err) {
                  console.warn('Nwasm: syncArcadeGames after addGame failed:', err);
                }
              }

              // Refresh Arcade library overlay if it is open.
              if (!((_this$arcade_overlay2 = this.arcade_overlay) !== null && _this$arcade_overlay2 !== void 0 && _this$arcade_overlay2.is_open)) {
                _context11.n = 10;
                break;
              }
              _context11.p = 7;
              _context11.n = 8;
              return this.arcade_overlay.refresh();
            case 8:
              _context11.n = 10;
              break;
            case 9:
              _context11.p = 9;
              _t4 = _context11.v;
              console.warn('Nwasm: arcade overlay refresh failed:', _t4);
            case 10:
              return _context11.a(2, entry);
          }
        }, _callee11, this, [[7, 9], [1, 3]]);
      }));
      function addGame() {
        return _addGame.apply(this, arguments);
      }
      return addGame;
    }() //
    // After Upload to Vault is confirmed, register the game from the mint tx /
    // upload result — do not ask Vault for metadata.
    //
  }, {
    key: "addGameFromVaultResult",
    value: function () {
      var _addGameFromVaultResult = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _ctx$game_data, _this$app$options2, _nft_entry$slip, _nft_entry$slip2, _nft_entry$slip3;
        var ctx,
          result,
          name,
          filename,
          nft_tx,
          nft_id,
          tx_sig,
          nfts,
          nft_entry,
          msg,
          _nft_tx$returnMessage,
          data,
          file_id,
          file,
          title,
          _args12 = arguments,
          _t5;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              ctx = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
              result = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : {};
              name = (((_ctx$game_data = ctx.game_data) === null || _ctx$game_data === void 0 ? void 0 : _ctx$game_data.name) || ctx.file_name || '').trim() || 'game';
              filename = ((result === null || result === void 0 ? void 0 : result.filename) || ctx.file_name || "".concat(name, ".z64")).trim();
              if (!/\.(z64|n64|v64)$/i.test(filename)) {
                filename = "".concat(filename.replace(/\.[^.]+$/, '') || name, ".z64");
              }
              _context12.p = 1;
              _context12.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              _context12.n = 4;
              break;
            case 3:
              _context12.p = 3;
              _t5 = _context12.v;
              console.warn('Nwasm.addGameFromVaultResult: updateNFTList failed:', _t5);
            case 4:
              nft_tx = (result === null || result === void 0 ? void 0 : result.nft_tx) || null;
              nft_id = (result === null || result === void 0 ? void 0 : result.nft_id) || '';
              tx_sig = (nft_tx === null || nft_tx === void 0 ? void 0 : nft_tx.signature) || '';
              nfts = ((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.wallet) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.nfts) || [];
              nft_entry = nfts.find(function (n) {
                return nft_id && n.id === nft_id || tx_sig && n.tx_sig === tx_sig;
              }) || null;
              msg = {};
              try {
                msg = (nft_tx === null || nft_tx === void 0 || (_nft_tx$returnMessage = nft_tx.returnMessage) === null || _nft_tx$returnMessage === void 0 ? void 0 : _nft_tx$returnMessage.call(nft_tx)) || (nft_tx === null || nft_tx === void 0 ? void 0 : nft_tx.msg) || {};
              } catch (err) {
                msg = {};
              }
              data = msg.data && _typeof(msg.data) === 'object' ? msg.data : {};
              file_id = String((result === null || result === void 0 ? void 0 : result.file_id) || data.file_id || '');
              filename = String(data.filename || filename);
              nft_id = String(nft_id || (nft_entry === null || nft_entry === void 0 ? void 0 : nft_entry.id) || '');
              tx_sig = String(tx_sig || (nft_entry === null || nft_entry === void 0 ? void 0 : nft_entry.tx_sig) || '');
              if (!(!file_id || !tx_sig && !nft_tx)) {
                _context12.n = 5;
                break;
              }
              throw new Error('Vault upload confirmed but Access Key mint transaction data is not available to register');
            case 5:
              file = {
                nft_id: nft_id || tx_sig,
                tx_sig: tx_sig,
                file_id: file_id,
                filename: filename,
                link: data.link != null ? String(data.link) : '',
                slip1_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip = nft_entry.slip1) === null || _nft_entry$slip === void 0 ? void 0 : _nft_entry$slip.utxo_key) || '',
                slip2_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip2 = nft_entry.slip2) === null || _nft_entry$slip2 === void 0 ? void 0 : _nft_entry$slip2.utxo_key) || '',
                slip3_utxokey: (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip3 = nft_entry.slip3) === null || _nft_entry$slip3 === void 0 ? void 0 : _nft_entry$slip3.utxo_key) || '',
                file_access_script: data.file_access_script || null
              };
              this.rememberVaultNftIndex(tx_sig || file.nft_id, _objectSpread({
                status: 'rom'
              }, file));
              title = filename.replace(/\.(z64|n64|v64)$/i, '').trim() || name;
              _context12.n = 6;
              return this.addGame(nft_tx, {
                source: 'vault',
                title: title,
                id: file.nft_id || tx_sig,
                sig: tx_sig,
                vault: file
              });
            case 6:
              return _context12.a(2, _context12.v);
          }
        }, _callee12, this, [[1, 3]]);
      }));
      function addGameFromVaultResult() {
        return _addGameFromVaultResult.apply(this, arguments);
      }
      return addGameFromVaultResult;
    }() //
    // NWASM-owned classification of Vault NFTs (not Vault's options.vault.files).
    //
  }, {
    key: "rememberVaultNftIndex",
    value: function rememberVaultNftIndex(key, entry) {
      if (!key || !entry) {
        return;
      }
      if (!this.app.options.nwasm) {
        this.app.options.nwasm = {};
      }
      if (!this.app.options.nwasm.vault_nft_index || _typeof(this.app.options.nwasm.vault_nft_index) !== 'object') {
        this.app.options.nwasm.vault_nft_index = {};
      }
      this.app.options.nwasm.vault_nft_index[key] = entry;
      this.app.storage.saveOptions();
    }
  }, {
    key: "deleteRoms",
    value: function () {
      var _deleteRoms = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              this.app.storage.deleteTransactions({
                field1: this.name,
                field2: this.publicKey
              }, function () {
                try {
                  alert('Transactions deleted');
                } catch (err) {
                  console.log('error running alert when transactions deleted');
                }
              }, null);
            case 1:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function deleteRoms() {
        return _deleteRoms.apply(this, arguments);
      }
      return deleteRoms;
    }()
  }, {
    key: "returnAdvancedOptions",
    value: function returnAdvancedOptions() {
      return NwasmGameOptionsTemplate(this.app, this);
    }

    //
    // Saito Module gets feedback from the N64 Emulator by monitoring the console log
    // for updates on the state of the program execution (has it initialized? have we
    // saved? etc.).
    //
    // for the love of God don't add console.logs within this function or you'll throw
    // execution into an infinite loop.
    //
  }, {
    key: "processNwasmLog",
    value: function () {
      var _processNwasmLog = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var logline,
          log,
          x,
          nwasm_self,
          len,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              logline = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : '';
              log = _args14.length > 1 ? _args14[1] : undefined;
              x = logline;
              nwasm_self = this;
              if (logline.indexOf('mupen64plus: ') == 0) {
                x = logline.substring(13);
                if (x.indexOf('Name: ') == 0) {
                  x = x.substring(6);
                  if (x.indexOf('muopen') > -1) {
                    x = x.substring(0, x.indexOf('muopen'));
                  }
                  len = x.trim().length;
                  if (len > 6) {
                    len = 6;
                  }

                  //
                  // ROM title / save lookup only. Loading overlay is dismissed from
                  // LoadEmulator after initAudio (first boot and soft-restart).
                  //
                  if (this.active_rom_name.indexOf(x.trim().substring(0, len)) != 0) {
                    this.active_rom_name = x.trim();
                    this.active_rom_sig = this.app.crypto.hash(this.active_rom_name);

                    //
                    // Local persistence is explicit via "Save to Local Archive".
                    // Play Game Now must not silently create an archive entry.
                    //
                    this.uploaded_rom = true;

                    //
                    // load 5 saved games
                    //
                    this.app.storage.loadTransactions({
                      field1: 'Nwasm' + this.active_rom_sig,
                      limit: 5
                    }, function (txs) {
                      try {
                        for (var z = 0; z < txs.length; z++) {
                          var newtx = txs[z];
                          nwasm_self.active_game_saves.push(newtx);
                        }
                      } catch (err) {
                        log('error loading Nwasm game...: ' + err);
                      }
                    });
                  }
                }
              }
            case 1:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function processNwasmLog() {
        return _processNwasmLog.apply(this, arguments);
      }
      return processNwasmLog;
    }() //////////////////
    // transactions //
    //////////////////
    //
    // Wrap raw ROM bytes as a temporary tx so extractRom can reuse the
    // archive/local loading path (title seeding, startPlaying, initializeRom).
    // Uses the same msg.data shape as NFT / Archive: { module, name, file }.
    //
  }, {
    key: "packRom",
    value: function packRom(base64) {
      var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var title = (meta.title || meta.filename || meta.name || '').trim();
      var file = typeof base64 === 'string' && base64.indexOf('data:') === 0 ? base64 : "data:application/octet-stream;base64,".concat(base64);
      var tx = new Transaction();
      tx.msg = {
        module: this.name,
        id: meta.id || '',
        title: title,
        name: title,
        data: {
          module: 'Nwasm',
          name: title,
          file: file
        }
      };
      return tx;
    }

    //
    // Vault may return either a legacy raw-ROM payload or a JSON envelope whose
    // `.data` is the canonical N-WASM game object. Converge both onto a tx that
    // extractRom understands.
    //
  }, {
    key: "unpackVaultFile",
    value: function unpackVaultFile(base64) {
      var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        var _msg$data3, _msg$data4;
        var text = Buffer.from(base64, 'base64').toString('utf8');
        var msg = JSON.parse(text);
        if ((msg === null || msg === void 0 || (_msg$data3 = msg.data) === null || _msg$data3 === void 0 ? void 0 : _msg$data3.module) === 'Nwasm' && msg !== null && msg !== void 0 && (_msg$data4 = msg.data) !== null && _msg$data4 !== void 0 && _msg$data4.file) {
          var title = (msg.title || msg.name || msg.data.name || meta.title || '').trim();
          var tx = new Transaction();
          tx.msg = {
            module: this.name,
            id: meta.id || '',
            title: title,
            name: title,
            data: msg.data
          };
          return tx;
        }
      } catch (err) {}
      return this.packRom(base64, meta);
    }
  }, {
    key: "extractRom",
    value: function extractRom(tx) {
      var _base64$split$;
      var txmsg = tx.returnMessage();
      var secret_key = txmsg.key || '';
      var base64 = txmsg.data;
      if (txmsg.data && _typeof(txmsg.data) === 'object' && txmsg.data.file) {
        base64 = txmsg.data.file;
      }
      if (typeof base64 !== 'string') {
        throw new Error('N-WASM transaction missing ROM file data');
      }
      var rbase64 = (_base64$split$ = base64.split('base64,')[1]) !== null && _base64$split$ !== void 0 ? _base64$split$ : base64;
      var ab = '';
      if (secret_key != '') {
        ab = this.convertBase64ToByteArray(this.xorBase64(rbase64, secret_key));
      } else {
        ab = this.convertBase64ToByteArray(rbase64);
      }

      //
      // prevents us saving the file, this is an already uploaded rom
      //
      this.uploaded_rom = true;
      this.active_game_saves = [];

      //
      // Seed title/sig from archive metadata so Load can query saves before the
      // emulator Name log arrives.
      //
      var rom_title = (txmsg.title || txmsg.name || '').trim();
      if (rom_title) {
        this.active_rom_name = rom_title;
        this.active_rom_sig = this.app.crypto.hash(this.active_rom_name);
      }
      this.startPlaying();
      // LoadEmulator: cold callMain | same-ROM soft-reset | different-ROM page reload.
      myApp.initializeRom(ab, this.app, this);
    }
  }, {
    key: "loadSaveGame",
    value: function loadSaveGame(sig) {
      for (var i = 0; i < this.active_game_saves.length; i++) {
        var newtx = this.active_game_saves[i];
        if (sig === newtx.signature) {
          var txmsg = newtx.returnMessage();
          var byteArray = this.convertBase64ToByteArray(txmsg.data);
          this.active_game = byteArray;
          //
          // importEep writes the savestate and unserializes without depending on
          // the IndexedDB lookup inside loadStateLocal.
          //
          myApp.importEep(byteArray);
        }
      }
    }
  }, {
    key: "loadGameFile",
    value: function loadGameFile() {
      var nwasm_mod = this;
      this.app.storage.loadTransactions({
        field1: 'Nwasm' + this.active_rom_sig,
        limit: 1
      }, function (txs) {
        try {
          if (txs.length <= 0) {
            alert('No Saved Games Available');
          }
          var newtx = txs[0];
          var txmsg = newtx.returnMessage();
          var byteArray = nwasm_mod.convertBase64ToByteArray(txmsg.data);
          nwasm_mod.active_game = byteArray;
          nwasm_mod.active_game_time_played = txmsg.time_played;
          nwasm_mod.startPlaying();
          myApp.importEep(byteArray);
        } catch (err) {
          console.log('error loading Nwasm game...: ' + err);
        }
      });
    }
  }, {
    key: "saveGameFile",
    value: function () {
      var _saveGameFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
        var base64data, screenshot, newtx, obj;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              base64data = this.convertByteArrayToBase64(data);
              _context15.n = 1;
              return this.app.browser.resizeImg(this.active_game_img);
            case 1:
              screenshot = _context15.v;
              _context15.n = 2;
              return this.app.wallet.createUnsignedTransaction();
            case 2:
              newtx = _context15.v;
              this.stopPlaying();
              obj = {
                module: this.name + this.active_rom_sig,
                request: 'upload savegame',
                name: this.active_rom_name.trim(),
                screenshot: screenshot,
                time_played: this.active_game_time_played,
                data: base64data
              };
              newtx.msg = obj;
              _context15.n = 3;
              return newtx.sign();
            case 3:
              _context15.n = 4;
              return this.app.storage.saveTransaction(newtx, {
                field1: 'Nwasm' + this.active_rom_sig
              });
            case 4:
              this.active_game_saves.push(newtx);
            case 5:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function saveGameFile(_x1) {
        return _saveGameFile.apply(this, arguments);
      }
      return saveGameFile;
    }() /////////////////////
    // data conversion //
    /////////////////////
  }, {
    key: "convertByteArrayToBase64",
    value: function convertByteArrayToBase64(data) {
      return Buffer.from(data, 'binary').toString('base64');
    }
  }, {
    key: "convertBase64ToByteArray",
    value: function convertBase64ToByteArray(data) {
      var b = Buffer.from(data, 'base64');
      var b2 = new Uint8Array(b.length);
      for (var i = 0; i < b.length; ++i) {
        b2[i] = b[i];
      }
      return b2;
    }
  }, {
    key: "xorBase64",
    value: function xorBase64(data, secret_key) {
      var b = Buffer.from(data, 'base64');
      var r = Buffer.from(secret_key, 'utf8');
      return xorInplace(b, r).toString('base64');
    }

    ////////////////////////
    // saving and loading //
    ////////////////////////
  }, {
    key: "exportState",
    value: function exportState() {
      var nwasm_mod = this;
      this.app.browser.screenshotCanvasElementById('canvas', function (img) {
        nwasm_mod.active_game_img = img;
        myApp.saveStateLocal();
        myApp.exportStateLocal();
      });
    }
  }]);
}(OnePlayerGameTemplate);
module.exports = Nwasm;